import React, { useState } from 'react';
import { FBCatalogue } from './FBCatalogue';
import { FBInventory } from './FBInventory';
export function FBOperations() {
  const [activeSubTab, setActiveSubTab] = useState<'catalogue' | 'inventory'>('catalogue');
  return <div className="flex flex-col h-full" data-id="element-477">
      <header className="mb-6 flex flex-col sm:flex-row sm:items-end justify-between gap-4" data-id="element-478">
        <div data-id="element-479">
          <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-480">
            Food & Beverage
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-481">
            Manage your concession stand catalogue and track inventory levels
          </p>
        </div>

        {/* Sub-tab Navigation */}
        <div className="flex p-1 bg-gray-200 rounded-lg w-fit" data-id="element-482">
          <button onClick={() => setActiveSubTab('catalogue')} className={`px-4 py-1.5 text-sm font-semibold rounded-md transition-all ${activeSubTab === 'catalogue' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-483">
            Catalogue Builder
          </button>
          <button onClick={() => setActiveSubTab('inventory')} className={`px-4 py-1.5 text-sm font-semibold rounded-md transition-all ${activeSubTab === 'inventory' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-484">
            Inventory Dashboard
          </button>
        </div>
      </header>

      {/* Content Area */}
      {activeSubTab === 'catalogue' ? <FBCatalogue data-id="element-485" /> : <FBInventory data-id="element-486" />}
    </div>;
}